
export class BudgetComponent {
  description: string = '';
  cost: number = 0;
  isDefault: boolean = false;
}
